import { Controller } from "@hotwired/stimulus"
// import tippy from 'tippy.js';
import ky from 'ky';
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)
import flatpickr from "flatpickr";
import { Russian } from 'flatpickr/dist/l10n/ru.js'
export default class extends Controller {
  static targets = [
    "auto_drawer_checkbox",
    "manual_drawer_checkbox",
    "robot_drawer_checkbox",
    "variator_drawer_checkbox",
    "gasolina_drawer_checkbox",
    "gasoleo_drawer_checkbox",
    "electro_drawer_checkbox",
    "kasko_drawer_checkbox",
    "super_kasko_drawer_checkbox",
    "no_deposit_drawer_checkbox",
    "card_payment_drawer_checkbox",
    "cash_payment_drawer_checkbox",
    "no_mileage_drawer_checkbox",

  ];
  static values = {
    filters: Array,
  }
  connect() {
    console.log("results_controller connected")
    // initial=true: первичная автозагрузка не переписывает URL в ?params-версию
    // (её блокирует robots Disallow: /*?*). Чистый URL остаётся каноническим.
    this.showResults(false, false, true);
  }
  submit() {
    this.showResults(false, false, false);
  }
  showResults(load_more, load_more_partners, initial = false) {
    // Костыль, приходит в параметрах event
    if (typeof load_more != "boolean") {
      load_more = false;
    }
    console.log("showResults");
    var search_params = new URLSearchParams(window.location.search)
    // const url_params = window.location.pathname.split("/")

    let car_classes = ["econom", "middle", "business", "commercial"]
    let car_types = [
      "micro",
      "hatchback",
      "compact",
      "sedan",
      "universal",
      "minivan",
      "coupe",
      "crossover",
      "suv",
      "pickup",
      "limousine",
      "van",
      "convertible",
      "microbus",
      "campervan",
      "light_van",
      "roadster",
      "sportcar",
    ]
    let valuesTypes = {
      micro: "Микро",
      hatchback: "Хэтчбек",
      sedan: "Седан",
      universal: "Универсал",
      minivan: "Минивен",
      coupe: "Купе",
      crossover: "Кроссовер",
      suv: "Внедорожник",
      pickup: "Пикап",
      limousine: "Лимузин",
      van: "Фургон",
      convertible: "Кабриолет",
      microbus: "Микроавтобус",
      campervan: "Автодом",
      light_van: "Легковой фургон",
      roadster: "Родстер",
      sportcar: "Спорткар",
      econom: "Эконом",
      middle: "Средний",
      business: "Бизнес",
      commercial: "Коммерческий",
      compact: "Компакт",
    }
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("no_results").classList.add("hidden");
    document.getElementById("total_results").classList.add("hidden");
    document.getElementById("load_more").classList.add("hidden");

    if (document.getElementById("latitude") && document.getElementById("latitude").value) {
      search_params.set("latitude", document.getElementById("latitude").value);
    }
    if (document.getElementById("type_or_class") && document.getElementById("type_or_class").value) {
      let type_or_class = document.getElementById("type_or_class").value;
      if (car_classes.includes(type_or_class)) {
        search_params.set("car_class", type_or_class);
      } else if (car_types.includes(type_or_class)) {
        search_params.set("car_type", type_or_class);
      }
    }
    if (document.getElementById("longitude") && document.getElementById("longitude").value) {
      search_params.set("longitude", document.getElementById("longitude").value);
    }
    if (document.getElementById("city_iso") && document.getElementById("city_iso").value) {
      console.log("city_iso", document.getElementById("city_iso").value)
      search_params.set("city_iso", document.getElementById("city_iso").value);
    }
    if (document.getElementById("start_date") && document.getElementById("start_date").value && document.getElementById("start_time") && document.getElementById("start_time").value) {
      console.log("start_date", document.getElementById("start_date").value)
      let start_date = dayjs(document.getElementById("start_date").value, "YYYY-MM-DD").format("DD-MM-YYYY")
      search_params.set("start_date", `${start_date} ${document.getElementById("start_time").value}`);
    }
    if (document.getElementById("end_date") && document.getElementById("end_date").value) {
      let end_date = dayjs(document.getElementById("end_date").value, "YYYY-MM-DD").format("DD-MM-YYYY")
      search_params.set("end_date", `${end_date} ${document.getElementById("end_time").value}`);
    }
    if (search_params.get("start_date") && search_params.get("end_date") && search_params.get("latitude") && search_params.get("longitude")) {
      let url = `${window.location.origin}${window.location.pathname}?city_iso=${search_params.get("city_iso")}&latitude=${search_params.get("latitude")}&longitude=${search_params.get("longitude")}&start_date=${search_params.get("start_date")}&end_date=${search_params.get("end_date")}&car_class=${search_params.get("car_class")}&car_type=${search_params.get("car_type")}&auto_gearbox=${search_params.get("auto_gearbox")}&manual_gearbox=${search_params.get("manual_gearbox")}&robot_gearbox=${search_params.get("robot_gearbox")}&variator_gearbox=${search_params.get("variator_gearbox")}&gasolina=${search_params.get("gasolina")}&gasoleo=${search_params.get("gasoleo")}&electro=${search_params.get("electro")}&kasko=${search_params.get("kasko")}&super_kasko=${search_params.get("super_kasko")}&no_deposit=${search_params.get("no_deposit")}&card_payment=${search_params.get("card_payment")}&cash_payment=${search_params.get("cash_payment")}&no_mileage=${search_params.get("no_mileage")}&sort=${search_params.get("sort")}&pickup_city_id=${search_params.get("pickup_city_id")}`;
      if (!initial) window.history.replaceState(null, null, url);
    }

    // Красим кнопки фильтров
    if (search_params.get("car_class") == "null" && search_params.get("car_type") == "null") {
      document.getElementById("all_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.add("bg-gray-800", "text-white");
    } else {
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
    }

    if (search_params.has("start_date") && search_params.has("end_date") && search_params.get("longitude") && search_params.get("latitude")) {
      console.log("has dates")
      let start_datetime = dayjs(search_params.get("start_date"), "DD-MM-YYYY HH:mm").isValid() ? dayjs(search_params.get("start_date"), "DD-MM-YYYY HH:mm").format("DD-MM-YYYY HH:mm") : dayjs().add(2, 'day').format("DD-MM-YYYY HH:mm");
      let end_datetime = dayjs(search_params.get("end_date"), "DD-MM-YYYY HH:mm").isValid() ? dayjs(search_params.get("end_date"), "DD-MM-YYYY HH:mm").format("DD-MM-YYYY HH:mm") : dayjs().add(5, 'day').format("DD-MM-YYYY HH:mm");
      if (document.getElementById("start_date")) {
        document.getElementById("start_date").value = dayjs(start_datetime, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY");
      }
      if (document.getElementById("end_date")) {
        document.getElementById("end_date").value = dayjs(end_datetime, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY");;
      }
      var start_date_instance = flatpickr("#start_date", {
        locale: Russian,
        date_format: "d-m-Y",
        minDate: dayjs().startOf('date').toDate(),
        altInput: true,
        altFormat: "d-m-Y",
        altInputClass: "block w-full border-y-0 border-l-0 border-r border-gray-800 text-gray-800 placeholder-gray-500 focus:ring-0 text-base",
        disableMobile: "true",
      });
      var end_date_instance = flatpickr("#end_date", {
        locale: Russian,
        date_format: "d-m-Y",
        minDate: dayjs(start_datetime, "DD-MM-YYYY HH:mm").add(1, 'day').toDate(),
        altInput: true,
        altFormat: "d-m-Y",
        altInputClass: "block w-full border-y-0 border-l-0 border-r border-gray-800 text-gray-800 placeholder-gray-500 focus:ring-0 text-base",
        disableMobile: "true",
      });
      start_date_instance.setDate(dayjs(start_datetime, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY"), false, "d-m-Y");

      end_date_instance.setDate(dayjs(end_datetime, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY"), false, "d-m-Y");
      document.getElementById("start_time").value = dayjs(start_datetime, "DD-MM-YYYY HH:mm").format("HH:mm");
      document.getElementById("end_time").value = dayjs(end_datetime, "DD-MM-YYYY HH:mm").format("HH:mm");

      if (dayjs(start_datetime, "DD-MM-YYYY HH:mm").isValid() && dayjs(end_datetime, "DD-MM-YYYY HH:mm").isValid()) {
        let loaders_element = document.getElementById("loaders");
        loaders_element.classList.remove("hidden");
        let scroll_to = document.getElementById("top_results");
        if (!load_more) {
          scroll_to.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }
        let url = `https://rentprog.net/api/v1/search_free_cars`
        if (document.querySelector('meta[name="environment"]').content == "development") {
          url = `http://localhost:3000/api/v1/search_free_cars`
        }

        let page = document.getElementById("page") ? document.getElementById("page").value : 1;
        let car_class = search_params.get("car_class");
        let car_type = search_params.get("car_type");


        try {
          const response = ky.post(url, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': document.querySelector('meta[name="crfs-token"]').content
            },
            json: {
              start_date: start_datetime,
              end_date: end_datetime,
              latitude: search_params.get("latitude"),
              longitude: search_params.get("longitude"),
              car_class: car_classes.includes(car_class) ? valuesTypes[car_class] : null,
              car_type: car_types.includes(car_type) ? valuesTypes[car_type] : null,
              auto_gearbox: search_params.get("auto_gearbox"),
              manual_gearbox: search_params.get("manual_gearbox"),
              robot_gearbox: search_params.get("robot_gearbox"),
              variator_gearbox: search_params.get("variator_gearbox"),
              gasolina: search_params.get("gasolina"),
              gasoleo: search_params.get("gasoleo"),
              electro: search_params.get("electro"),
              kasko: search_params.get("kasko"),
              super_kasko: search_params.get("super_kasko"),
              no_deposit: search_params.get("no_deposit"),
              card_payment: search_params.get("card_payment"),
              cash_payment: search_params.get("cash_payment"),
              no_mileage: search_params.get("no_mileage"),
              sort: search_params.get("sort") ? search_params.get("sort") : "standart",
              page: page
            },
            hooks: {
              beforeError: [
                error => {
                  const { response } = error;
                  if (response && response.body) {
                    error.name = 'Loading Error';
                    error.message = `${response.body.message} (${response.status})`;
                  }
                  document.getElementById("loaders").classList.add("hidden");
                  console.log(error);
                  alert(error);
                }
              ]
            },
            retry: 0
          });
          response.then((data) => {
            this.loadResults(data, search_params, load_more);
            // if ((!load_more || load_more_partners) && ((search_params.get("pickup_city_id") && search_params.get("pickup_city_id") != "null" && search_params.get("pickup_city_id") != null && search_params.get("pickup_city_id") != undefined))) {
            //   this.loadPartnersResults(load_more, load_more_partners, 1);
            // }
          });
        } catch (error) {
          document.getElementById("loaders").classList.add("hidden");
          console.log(error);
          alert(error);
        }
      } else {
        // alert("Выберите дату");
      }
    } else {
      console.log("No dates");
      if (search_params.get("longitude") && search_params.get("latitude")) {

        let url = `https://rentprog.net/api/v1/search_free_cars`
        if (document.querySelector('meta[name="environment"]').content == "development") {
          url = `http://localhost:3000/api/v1/search_free_cars`
        }

        let page = document.getElementById("page") ? document.getElementById("page").value : 1;

        try {
          const response = ky.post(url, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': document.querySelector('meta[name="crfs-token"]').content
            },
            json: {
              latitude: search_params.get("latitude"),
              longitude: search_params.get("longitude"),
              page: page
            },
            hooks: {
              beforeError: [
                error => {
                  const { response } = error;
                  if (response && response.body) {
                    error.name = 'Loading Error';
                    error.message = `${response.body.message} (${response.status})`;
                  }
                  document.getElementById("loaders").classList.add("hidden");
                  console.log(error);
                  alert(error);
                }
              ]
            },
            retry: 0
          });
          response.then((data) => {
            this.loadResults(data, search_params, load_more);
          });
        } catch (error) {
          document.getElementById("loaders").classList.add("hidden");
          console.log(error);
          alert(error);
        }
      } else {
        document.getElementById("loaders").classList.add("hidden");
        console.log("No city");
      }
    }
  }
  // Отправляет минимальную цену по текущему городу в наш кэш (best-effort).
  // Использует уже полученные результаты поиска — без доп. запросов к rentprog.
  reportPriceFrom(json) {
    try {
      const cityEl = document.getElementById("city_id");
      const cityId = cityEl && cityEl.value;
      if (!cityId) return;

      const cars = (json && json.cars && json.cars.data) || [];
      const prices = cars
        .map((c) => parseInt(c.selected_price, 10))
        .filter((p) => Number.isFinite(p) && p > 0);
      if (prices.length === 0) return;

      const body = new FormData();
      body.append("city_id", cityId);
      body.append("min_price", String(Math.min(...prices)));
      navigator.sendBeacon("/seo/price_beacon", body);
    } catch (e) {
      // beacon — необязательный; молча игнорируем ошибки
    }
  }

  loadResults(data, search_params, load_more) {
    data.json().then((json) => {
      let element = document.getElementById("loaders")
      element.classList.add("hidden");
      let results_element = document.getElementById("results");
      const loader_gif = `${window.location.origin}/loading.gif`;
      if (json.cars.data != undefined && json.cars.data.length > 0) {
        let results = "";
        let cars_all_count = json.total_count

        // SEO client-beacon: на первой странице шлём min-цену по городу в наш
        // кэш, чтобы показывать «цена от» без запросов к rentprog на рендере.
        if (!load_more) {
          this.reportPriceFrom(json);
        }

        let cars_micro_count = json.facets_data.car_type["Микро"] ? json.facets_data.car_type["Микро"] : 0
        let cars_hatchback_count = json.facets_data.car_type["Хэтчбек"] ? json.facets_data.car_type["Хэтчбек"] : 0
        let cars_compact_count = cars_micro_count + cars_hatchback_count
        if (cars_all_count > 0) {
          document.getElementById("all_filter").disabled = false
          document.getElementById("all_filter").innerHTML = `Все`
        } else {
          document.getElementById("all_filter").disabled = true
          document.getElementById("all_filter").innerHTML = `Все`
        }
        if (cars_compact_count > 0) {
          document.getElementById("compact_filter").disabled = false
          document.getElementById("compact_filter_text").innerHTML = `Компактные (${cars_compact_count})`
          document.getElementById("compact_drawer_filter").disabled = false
          document.getElementById("compact_drawer_filter_text").innerHTML = `Компактные (${cars_compact_count})`
        } else {
          document.getElementById("compact_filter").disabled = true
          document.getElementById("compact_filter_text").innerHTML = `Компактные (0)`
          document.getElementById("compact_drawer_filter").disabled = true
          document.getElementById("compact_drawer_filter_text").innerHTML = `Компактные (0)`
        }
        if (cars_micro_count > 0) {
          document.getElementById("micro_drawer_filter").disabled = false
          document.getElementById("micro_drawer_filter_text").innerHTML = `Микро (${cars_micro_count})`
        } else {
          document.getElementById("micro_drawer_filter").disabled = true
          document.getElementById("micro_drawer_filter_text").innerHTML = `Микро (0)`
        }
        if (cars_hatchback_count > 0) {
          document.getElementById("hatchback_drawer_filter").disabled = false
          document.getElementById("hatchback_drawer_filter_text").innerHTML = `Хэтчбек (${cars_hatchback_count})`
        } else {
          document.getElementById("hatchback_drawer_filter").disabled = true
          document.getElementById("hatchback_drawer_filter_text").innerHTML = `Хэтчбек (0)`
        }
        let cars_sedan_count = json.facets_data.car_type["Седан"] ? json.facets_data.car_type["Седан"] : 0
        if (cars_sedan_count > 0) {
          document.getElementById("sedan_drawer_filter").disabled = false
          document.getElementById("sedan_drawer_filter_text").innerHTML = `Седаны (${cars_sedan_count})`
        } else {
          document.getElementById("sedan_drawer_filter").disabled = true
          document.getElementById("sedan_drawer_filter_text").innerHTML = `Седаны (0)`
        }
        let cars_minivan_count = json.facets_data.car_type["Минивен"] ? json.facets_data.car_type["Минивен"] : 0
        if (cars_minivan_count > 0) {
          document.getElementById("minivan_filter").disabled = false
          document.getElementById("minivan_filter_text").innerHTML = `Минивэны (${cars_minivan_count})`
          document.getElementById("minivan_drawer_filter").disabled = false
          document.getElementById("minivan_drawer_filter_text").innerHTML = `Минивэны (${cars_minivan_count})`
        } else {
          document.getElementById("minivan_filter").disabled = true
          document.getElementById("minivan_filter_text").innerHTML = `Минивэны (0)`
          document.getElementById("minivan_drawer_filter").disabled = true
          document.getElementById("minivan_drawer_filter_text").innerHTML = `Минивэны (0)`
        }
        let cars_crossover_count = json.facets_data.car_type["Кроссовер"] ? json.facets_data.car_type["Кроссовер"] : 0
        if (cars_crossover_count > 0) {
          document.getElementById("crossover_filter").disabled = false
          document.getElementById("crossover_filter_text").innerHTML = `Кроссоверы (${cars_crossover_count})`
          document.getElementById("crossover_drawer_filter").disabled = false
          document.getElementById("crossover_drawer_filter_text").innerHTML = `Кроссоверы (${cars_crossover_count})`
        } else {
          document.getElementById("crossover_filter").disabled = true
          document.getElementById("crossover_filter_text").innerHTML = `Кроссоверы (0)`
          document.getElementById("crossover_drawer_filter").disabled = true
          document.getElementById("crossover_drawer_filter_text").innerHTML = `Кроссоверы (0)`
        }
        let cars_middle_count = json.facets_data.car_class["Средний"] ? json.facets_data.car_class["Средний"] : 0
        if (cars_middle_count > 0) {
          document.getElementById("middle_filter").disabled = false
          document.getElementById("middle_filter_text").innerHTML = `Средний класс (${cars_middle_count})`
          document.getElementById("middle_drawer_filter").disabled = false
          document.getElementById("middle_drawer_filter_text").innerHTML = `Средний класс (${cars_middle_count})`
        } else {
          document.getElementById("middle_filter").disabled = true
          document.getElementById("middle_filter_text").innerHTML = `Средний класс (0)`
          document.getElementById("middle_drawer_filter").disabled = true
          document.getElementById("middle_drawer_filter_text").innerHTML = `Средний класс (0)`
        }
        let cars_business_count = json.facets_data.car_class["Бизнес"] ? json.facets_data.car_class["Бизнес"] : 0
        if (cars_business_count > 0) {
          document.getElementById("business_filter").disabled = false
          document.getElementById("business_filter_text").innerHTML = `Бизнес (${cars_business_count})`
          document.getElementById("business_drawer_filter").disabled = false
          document.getElementById("business_drawer_filter_text").innerHTML = `Бизнес (${cars_business_count})`
        } else {
          document.getElementById("business_filter").disabled = true
          document.getElementById("business_filter_text").innerHTML = `Бизнес (0)`
          document.getElementById("business_drawer_filter").disabled = true
          document.getElementById("business_drawer_filter_text").innerHTML = `Бизнес (0)`
        }
        let cars_cabrio_count = json.facets_data.car_type["Кабриолет"] ? json.facets_data.car_type["Кабриолет"] : 0
        if (cars_cabrio_count > 0) {
          document.getElementById("cabrio_filter").disabled = false
          document.getElementById("cabrio_filter_text").innerHTML = `Кабрио (${cars_cabrio_count})`
          document.getElementById("cabrio_drawer_filter").disabled = false
          document.getElementById("cabrio_drawer_filter_text").innerHTML = `Кабрио (${cars_cabrio_count})`
        } else {
          document.getElementById("cabrio_filter").disabled = true
          document.getElementById("cabrio_filter_text").innerHTML = `Кабрио (0)`
          document.getElementById("cabrio_drawer_filter").disabled = true
          document.getElementById("cabrio_drawer_filter_text").innerHTML = `Кабрио (0)`
        }

        let cars_universal_count = json.facets_data.car_type["Универсал"] ? json.facets_data.car_type["Универсал"] : 0
        if (cars_universal_count > 0) {
          document.getElementById("universal_drawer_filter").disabled = false
          document.getElementById("universal_drawer_filter_text").innerHTML = `Универсалы (${cars_universal_count})`
        } else {
          document.getElementById("universal_drawer_filter").disabled = true
          document.getElementById("universal_drawer_filter_text").innerHTML = `Универсалы (0)`
        }

        let cars_coupe_count = json.facets_data.car_type["Купе"] ? json.facets_data.car_type["Купе"] : 0
        if (cars_coupe_count > 0) {
          document.getElementById("coupe_drawer_filter").disabled = false
          document.getElementById("coupe_drawer_filter_text").innerHTML = `Купе (${cars_coupe_count})`
        } else {
          document.getElementById("coupe_drawer_filter").disabled = true
          document.getElementById("coupe_drawer_filter_text").innerHTML = `Купе (0)`
        }

        let cars_suv_count = json.facets_data.car_type["Внедорожник"] ? json.facets_data.car_type["Внедорожник"] : 0
        if (cars_suv_count > 0) {
          document.getElementById("suv_drawer_filter").disabled = false
          document.getElementById("suv_drawer_filter_text").innerHTML = `Внедорожники (${cars_suv_count})`
        } else {
          document.getElementById("suv_drawer_filter").disabled = true
          document.getElementById("suv_drawer_filter_text").innerHTML = `Внедорожники (0)`
        }

        let cars_pickup_count = json.facets_data.car_type["Пикап"] ? json.facets_data.car_type["Пикап"] : 0
        if (cars_pickup_count > 0) {
          document.getElementById("pickup_drawer_filter").disabled = false
          document.getElementById("pickup_drawer_filter_text").innerHTML = `Пикапы (${cars_pickup_count})`
        } else {
          document.getElementById("pickup_drawer_filter").disabled = true
          document.getElementById("pickup_drawer_filter_text").innerHTML = `Пикапы (0)`
        }

        let cars_limousine_count = json.facets_data.car_type["Лимузин"] ? json.facets_data.car_type["Лимузин"] : 0
        if (cars_limousine_count > 0) {
          document.getElementById("limousine_drawer_filter").disabled = false
          document.getElementById("limousine_drawer_filter_text").innerHTML = `Лимузины (${cars_limousine_count})`
        } else {
          document.getElementById("limousine_drawer_filter").disabled = true
          document.getElementById("limousine_drawer_filter_text").innerHTML = `Лимузины (0)`
        }

        let cars_van_count = json.facets_data.car_type["Фургон"] ? json.facets_data.car_type["Фургон"] : 0
        if (cars_van_count > 0) {
          document.getElementById("van_drawer_filter").disabled = false
          document.getElementById("van_drawer_filter_text").innerHTML = `Фургоны (${cars_van_count})`
        } else {
          document.getElementById("van_drawer_filter").disabled = true
          document.getElementById("van_drawer_filter_text").innerHTML = `Фургоны (0)`
        }

        let cars_microbus_count = json.facets_data.car_type["Микроавтобус"] ? json.facets_data.car_type["Микроавтобус"] : 0
        if (cars_microbus_count > 0) {
          document.getElementById("microbus_drawer_filter").disabled = false
          document.getElementById("microbus_drawer_filter_text").innerHTML = `Микроавтобусы (${cars_microbus_count})`
        } else {
          document.getElementById("microbus_drawer_filter").disabled = true
          document.getElementById("microbus_drawer_filter_text").innerHTML = `Микроавтобусы (0)`
        }

        let cars_campervan_count = json.facets_data.car_type["Автодом"] ? json.facets_data.car_type["Автодом"] : 0
        if (cars_campervan_count > 0) {
          document.getElementById("campervan_drawer_filter").disabled = false
          document.getElementById("campervan_drawer_filter_text").innerHTML = `Автодома (${cars_campervan_count})`
        } else {
          document.getElementById("campervan_drawer_filter").disabled = true
          document.getElementById("campervan_drawer_filter_text").innerHTML = `Автодома (0)`
        }

        let cars_light_van_count = json.facets_data.car_type["Легковой фургон"] ? json.facets_data.car_type["Легковой фургон"] : 0
        if (cars_light_van_count > 0) {
          document.getElementById("light_van_drawer_filter").disabled = false
          document.getElementById("light_van_drawer_filter_text").innerHTML = `Легковые фургоны (${cars_light_van_count})`
        } else {
          document.getElementById("light_van_drawer_filter").disabled = true
          document.getElementById("light_van_drawer_filter_text").innerHTML = `Легковые фургоны (0)`
        }

        let cars_roadster_count = json.facets_data.car_type["Родстер"] ? json.facets_data.car_type["Родстер"] : 0
        if (cars_roadster_count > 0) {
          document.getElementById("roadster_drawer_filter").disabled = false
          document.getElementById("roadster_drawer_filter_text").innerHTML = `Родстер (${cars_roadster_count})`
        } else {
          document.getElementById("roadster_drawer_filter").disabled = true
          document.getElementById("roadster_drawer_filter_text").innerHTML = `Родстер (0)`
        }

        let cars_sportcar_count = json.facets_data.car_type["Спорткар"] ? json.facets_data.car_type["Спорткар"] : 0
        if (cars_sportcar_count > 0) {
          document.getElementById("sportcar_drawer_filter").disabled = false
          document.getElementById("sportcar_drawer_filter_text").innerHTML = `Спорткар (${cars_sportcar_count})`
        } else {
          document.getElementById("sportcar_drawer_filter").disabled = true
          document.getElementById("sportcar_drawer_filter_text").innerHTML = `Спорткар (0)`
        }

        let cars_econom_count = json.facets_data.car_class["Эконом"] ? json.facets_data.car_class["Эконом"] : 0
        if (cars_econom_count > 0) {
          document.getElementById("econom_drawer_filter").disabled = false
          document.getElementById("econom_drawer_filter_text").innerHTML = `Эконом (${cars_econom_count})`
        } else {
          document.getElementById("econom_drawer_filter").disabled = true
          document.getElementById("econom_drawer_filter_text").innerHTML = `Эконом (0)`
        }

        let cars_commercial_count = json.facets_data.car_class["Коммерческий"] ? json.facets_data.car_class["Коммерческий"] : 0
        if (cars_commercial_count > 0) {
          document.getElementById("commercial_drawer_filter").disabled = false
          document.getElementById("commercial_drawer_filter_text").innerHTML = `Коммерческий (${cars_commercial_count})`
        } else {
          document.getElementById("commercial_drawer_filter").disabled = true
          document.getElementById("commercial_drawer_filter_text").innerHTML = `Коммерческий (0)`
        }
        json.cars.data.forEach((car_data) => {
          let car = car_data.attributes;
          let deposit_string = car.deposit && car.deposit > 0 ? (car.deposit + ' ₽ депозит') : 'Без депозита';
          results += `<a href="/cars/${car.id}?${search_params}" target="_blank" data-controller="card" data-turbo="false" class="car ${car.transmission == 'Механика' ? 'manual' : 'automatic'} car-card group flex flex-col h-full bg-white border border-slate-200 rounded-2xl overflow-hidden transition duration-200 ease-out hover:-translate-y-0.5 hover:shadow-brand-2 hover:border-slate-300">
            <div class="relative aspect-[16/10] bg-slate-100 overflow-hidden">
              <img id="car_image_${car.id}" class="car_image_${car.id} object-cover h-full w-full transition duration-300 group-hover:scale-[1.03]" src="${loader_gif}" loading="lazy">
              <div class="absolute top-2.5 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 bg-white/95 backdrop-blur text-ink-800 text-xs font-semibold px-3 py-1 rounded-full shadow-brand-1 whitespace-nowrap">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="oklch(0.58 0.13 158)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="flex-none"><path d="M20 6 9 17l-5-5"/></svg>
                <span>Проверен</span>
                ${car.fast_booking ? "<span class='w-px h-3.5 bg-slate-200 flex-none'></span><svg width='13' height='13' viewBox='0 0 24 24' fill='oklch(0.72 0.16 70)' class='flex-none'><path d='M13 2 4.5 13H11l-1 9 8.5-11H12z'/></svg><span>Моментальная</span>" : ''}
              </div>
            </div>
            <div class="p-4 flex flex-col gap-2 flex-1">
              <div class="flex items-start justify-between gap-2">
                <h3 class="text-lg font-bold text-ink-900 tracking-tight leading-snug line-clamp-2 min-w-0">${this.truncateString(this.titleCase(car.car_visual_name), 26)}</h3>
                <span class="inline-flex items-center gap-1 text-sm font-semibold text-ink-800 flex-none">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="oklch(0.78 0.14 80)"><path d="M12 2l3 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.9 21l1.2-6.8-5-4.9 6.9-1z"/></svg>5
                  <span class="text-slate-500 font-medium">· ${car.rided_bookings_count}</span>
                </span>
              </div>
              <div class="flex flex-wrap gap-1.5">
                <span class="text-xs text-slate-700 bg-slate-100 rounded-lg px-2 py-1 font-medium">${car.transmission}</span>
                ${car.year ? `<span class="text-xs text-slate-700 bg-slate-100 rounded-lg px-2 py-1 font-medium">${car.year}</span>` : ''}
              </div>
              <div class="mt-auto pt-3 border-t border-slate-200">
                <div class="flex items-baseline gap-1.5 flex-wrap mb-3">
                  <span class="text-xl font-extrabold text-ink-900 tracking-tight">${car.selected_price} ₽</span>
                  <span class="text-xs text-slate-600">/ сутки · ${deposit_string}</span>
                </div>
                <span class="vp-btn vp-btn-primary w-full">Забронировать</span>
              </div>
              <div id="price_value" class="hidden">${car.selected_price}</div>
              <div id="year_value" class="hidden">${car.year}</div>
              <div id="bookings_count_value" class="hidden">${car.rided_bookings_count}</div>
            </div></a>`
        });
        if (load_more) {
          console.log("load_more", load_more)
          results_element.innerHTML += results;
        } else {
          results_element.innerHTML = results;
        }
        results_element.classList.remove("hidden");
        document.getElementById("top_results").classList.remove("hidden");
        document.getElementById("no_results").classList.add("hidden");
        document.getElementById("total_results").classList.add("hidden");
        document.getElementById("load_more").classList.add("hidden");
        // document.getElementById("jumbotron").classList.add("hidden");

        // Всего результатов
        document.getElementById("total_results").classList.remove("hidden");
        document.getElementById("total_results_count").innerHTML = json.total_count;
        // количество результатов
        document.getElementById("results_count").innerHTML = document.getElementsByClassName("car").length;

        // Если результатов больше 12, то показываем кнопку "Показать еще"
        if (json.total_count > 12) {
          document.getElementById("load_more").classList.remove("hidden");
        }
        // Если показаны все результаты, то скрываем кнопку "Показать еще"
        if (document.getElementsByClassName("car").length == json.total_count || json.total_count < 12) {
          document.getElementById("load_more").classList.add("hidden");
          document.getElementById("page").value = 1;
        }
        json.cars.data.forEach((car) => {
          let images = document.getElementsByClassName("car_image_" + car.id);
          // html collection to array
          images = Array.from(images);
          images.forEach((image) => {
            var downloadingImage = new Image();
            downloadingImage.onload = function () {
              image.src = this.src;
            };
            downloadingImage.src = car.attributes.photo;
          });
        });
      } else if (json.cars.data == undefined) {
        document.getElementById("loaders").classList.add("hidden");
        document.getElementById("results").classList.add("hidden");
      } else {
        document.getElementById("loaders").classList.add("hidden");
        document.getElementById("no_results").classList.remove("hidden");
        document.getElementById("results").classList.add("hidden");
      }
    });
  }
  loadPartnersResults(load_more, load_more_partners, page) {
    console.log("loadPartnersResults")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("partners_header").classList.remove("hidden");
    document.getElementById("partners_loaders").classList.remove("hidden");
    // https://localrent.com/api/cars/searching?
    // key=ashev08_gmail_com&
    // signature=aa6078e935ec75c769a30e590f4fcab9&
    // timestamp=1&
    // limit=12&
    // offset=24&
    // locale=ru&
    // pickup_date=2023-07-01&
    // dropoff_date=2023-07-15&
    // dropoff_city_id=77441&
    // pickup_city_id=77441&
    // gearbox=0&
    // fuel[]=1&
    // fuel[]=2&
    // fuel[]=3&
    // drive[]=1&
    // drive[]=2&
    // drive[]=3&
    // cost_min=0&
    // cost_max=100000&
    // engine_min=1&
    // engine_max=4.3&
    // consumption_min=0&
    // consumption_max=18.5&
    // year=1996&
    // aff_id=7073
    // 77441 - Калининград
    let dropoff_city_id, pickup_city_id
    if (search_params.get("pickup_city_id")) {
      dropoff_city_id = search_params.get("pickup_city_id");
      pickup_city_id = search_params.get("pickup_city_id");
    }
    if (pickup_city_id == undefined) {
      return;
    }
    let limit = 12;
    let offset = 0;
    if (page && page > 1) {
      offset = limit * page - limit;
    }

    let locale = "ru";
    let pickup_date = dayjs(search_params.get("start_date"), "DD-MM-YYYY HH:mm").format("YYYY-MM-DD");
    let dropoff_date = dayjs(search_params.get("end_date"), "DD-MM-YYYY HH:mm").format("YYYY-MM-DD");
    let gearbox = '';
    if (search_params.get("auto_gearbox") == true || search_params.get("auto_gearbox") == "true" && (search_params.get("manual_gearbox") == false || search_params.get("manual_gearbox") == "false" || search_params.get("manual_gearbox") == null)) {
      gearbox = "gearbox=1&";
    }
    if (search_params.get("manual_gearbox") == true || search_params.get("manual_gearbox") == "true" && (search_params.get("auto_gearbox") == false || search_params.get("auto_gearbox") == "false" || search_params.get("auto_gearbox") == null)) {
      gearbox = "gearbox=0&";
    }
    // gasolina electro gasoleo
    let fuel = '';
    if (search_params.get("gasolina") == true || search_params.get("gasolina") == "true") {
      fuel += "fuel[]=1&";
    }
    if (search_params.get("gasoleo") == true || search_params.get("gasoleo") == "true") {
      fuel += "fuel[]=2&";
    }
    if (search_params.get("electro") == true || search_params.get("electro") == "true") {
      fuel += "fuel[]=3&";
    }
    let drive = 'drive[]=1&drive[]=2&drive[]=3&';
    let cost_min = 0;
    let cost_max = 100000;
    let url = `https://localrent.com/api/cars/searching?key=ashev08_gmail_com&signature=aa6078e935ec75c769a30e590f4fcab9&timestamp=1&limit=${limit}&offset=${offset}&locale=${locale}&pickup_date=${pickup_date}&dropoff_date=${dropoff_date}&dropoff_city_id=${pickup_city_id}&pickup_city_id=${pickup_city_id}&${gearbox}${fuel}${drive}cost_min=${cost_min}&cost_max=${cost_max}&engine_min=1&engine_max=4.3&consumption_min=0&consumption_max=18.5&year=1996&aff_id=7073`;
    console.log(url)
    try {
      const response = ky.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        hooks: {
          beforeError: [
            error => {
              const { response } = error;
              if (response && response.body) {
                error.name = 'Loading Error';
                error.message = `${response.body.message} (${response.status})`;
              }
              document.getElementById("partners_loaders").classList.add("hidden");
              console.log(error);
            }
          ]
        },
        retry: 0
      });
      response.then((data) => {
        // не грузим если уже все загрузили
        if (offset >= data.count) {
          document.getElementById("partners_load_more").classList.add("hidden");
          return;
        }
        let results_element = document.getElementById("partners_results");
        let html_results = "";
        data.json().then((data) => {
          if (data && data.cars && data.cars.length > 0) {
            document.getElementById("partners_loaders").classList.add("hidden");
            document.getElementById("partners_total_results").classList.remove("hidden");
            document.getElementById("partners_total_results_count").innerHTML = data.count;
            if (load_more_partners == true) {
              document.getElementById("partners_results_count").innerHTML = parseInt(document.getElementById("partners_results_count").innerHTML);
            } else {
              document.getElementById("partners_results_count").innerHTML = data.cars.length;
            }

            if (data.cars.length < data.count) {
              document.getElementById("partners_load_more").classList.remove("hidden");
            }
          } else {
            document.getElementById("partners_header").classList.add("hidden");
            document.getElementById("partners_loaders").classList.add("hidden");
            document.getElementById("partners_load_more").classList.add("hidden");
            document.getElementById("partners_total_results").classList.add("hidden");
            document.getElementById("partners_results_count").innerHTML = 0;
            document.getElementById("partners_results").innerHTML = "";
            return;
          }
          const loader_gif = `${window.location.origin}/loading.gif`;
          data.cars.forEach((car_data) => {
            let car = car_data;
            let deposit_string = car.deposit && car.deposit > 0 ? (car.deposit + ' ₽ депозит') : 'Без депозита';
            html_results += `<a href="${car.full_url}&search_id=${data.search_id}" target="_blank" data-controller="card" data-turbo="false" class="car ${car.transmission == 1 ? 'manual' : 'automatic'} car-card group flex flex-col h-full bg-white border border-slate-200 rounded-2xl overflow-hidden transition duration-200 ease-out hover:-translate-y-0.5 hover:shadow-brand-2 hover:border-slate-300">
              <div class="relative aspect-[16/10] bg-slate-100 overflow-hidden">
                <img id="car_image_${car.id}" class="partners_car_image_${car.id} object-cover h-full w-full transition duration-300 group-hover:scale-[1.03]" src="${loader_gif}" loading="lazy">
                <span class="absolute top-2.5 right-2.5 inline-flex items-center bg-ink-900/80 text-white text-xs font-medium px-2.5 py-1 rounded-full">партнёр</span>
              </div>
              <div class="p-4 flex flex-col gap-2 flex-1">
                <h3 class="text-lg font-bold text-ink-900 tracking-tight leading-snug line-clamp-2 min-w-0">${this.truncateString(this.titleCase(car.full_name), 26)}</h3>
                <div class="flex flex-wrap gap-1.5">
                  <span class="text-xs text-slate-700 bg-slate-100 rounded-lg px-2 py-1 font-medium">${car.transmission == 1 ? 'Механика' : 'Автомат'}</span>
                  ${car.year ? `<span class="text-xs text-slate-700 bg-slate-100 rounded-lg px-2 py-1 font-medium">${car.year}</span>` : ''}
                </div>
                <div class="mt-auto pt-3 border-t border-slate-200">
                  <div class="flex items-baseline gap-1.5 flex-wrap mb-3">
                    <span class="text-xl font-extrabold text-ink-900 tracking-tight">${car.daily_cost} ₽</span>
                    <span class="text-xs text-slate-600">/ сутки · ${deposit_string}</span>
                  </div>
                  <span class="vp-btn vp-btn-primary w-full">Забронировать</span>
                </div>
              </div></a>`
          });
          if (load_more_partners) {
            console.log("load_more_partners", load_more_partners)
            results_element.innerHTML += html_results;
          } else {
            results_element.innerHTML = html_results;
          }
          results_element.classList.remove("hidden");
          data.cars.forEach((car) => {
            let images = document.getElementsByClassName("partners_car_image_" + car.id);
            // html collection to array
            images = Array.from(images);
            images.forEach((image) => {
              var downloadingImage = new Image();
              downloadingImage.onload = function () {
                image.src = car.image_url;
              };
              downloadingImage.src = car.image_url;
            });
          });
          document.getElementById("partners_results_count").textContent = page * limit;
        });
        // this.loadPartners(data, search_params, load_more);
      });
    } catch (error) {
      document.getElementById("loaders").classList.add("hidden");
      console.log(error);
      alert(error);
    }

  }
  loadMore() {
    console.log("loadMore")
    let page = document.getElementById("page").value;
    page++;
    document.getElementById("page").value = page;
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    this.showResults(true, false);
  }
  loadMorePartners() {
    console.log("loadMorePartners")
    let page = document.getElementById("partners_page").value;
    page++;
    document.getElementById("partners_page").value = page;
    document.getElementById("partners_loaders").classList.remove("hidden");
    this.loadPartnersResults(false, true, page);
  }
  showAll(event) {
    event.preventDefault();
    console.log("showAll")
    document.getElementById("loaders").classList.remove("hidden");
    var search_params = new URLSearchParams(window.location.search)
    search_params.set('car_type', null);
    search_params.set('car_class', null);
    search_params.set('auto_gearbox', null);
    search_params.set('manual_gearbox', null);
    search_params.set('robot_gearbox', null);
    search_params.set('variator_gearbox', null);
    search_params.set('gasolina', null);
    search_params.set('gasoleo', null);
    search_params.set('electro', null);
    search_params.set('kasko', null);
    search_params.set('super_kasko', null);
    search_params.set('no_deposit', null);
    search_params.set('card_payment', null);
    search_params.set('cash_payment', null);
    search_params.set('no_mileage', null);
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    document.getElementById("all_filter").classList.remove("text-gray-800", "bg-white");
    document.getElementById("all_filter").classList.add("bg-gray-800", "text-white");
    document.getElementById("compact_filter").classList.add("text-gray-800", "bg-white");
    document.getElementById("compact_filter").classList.remove("bg-gray-800", "text-white");
    document.getElementById("compact_filter_icon").classList.add("hidden")
    document.getElementById("compact_drawer_filter_icon").classList.add("hidden")
    document.getElementById("compact_drawer_filter").classList.add("text-gray-800", "bg-white");
    document.getElementById("compact_drawer_filter").classList.remove("bg-gray-800", "text-white");
    document.getElementById("middle_filter").classList.add("text-gray-800", "bg-white");
    document.getElementById("middle_filter").classList.remove("bg-gray-800", "text-white");
    document.getElementById("middle_drawer_filter").classList.add("text-gray-800", "bg-white");
    document.getElementById("middle_drawer_filter").classList.remove("bg-gray-800", "text-white");
    document.getElementById("middle_filter_icon").classList.add("hidden")
    document.getElementById("middle_drawer_filter_icon").classList.add("hidden")
    document.getElementById("crossover_filter").classList.add("text-gray-800", "bg-white");
    document.getElementById("crossover_filter").classList.remove("bg-gray-800", "text-white");
    document.getElementById("crossover_drawer_filter").classList.add("text-gray-800", "bg-white");
    document.getElementById("crossover_drawer_filter").classList.remove("bg-gray-800", "text-white");
    document.getElementById("crossover_filter_icon").classList.add("hidden")
    document.getElementById("crossover_drawer_filter_icon").classList.add("hidden")
    document.getElementById("business_filter").classList.add("text-gray-800", "bg-white");
    document.getElementById("business_filter").classList.remove("bg-gray-800", "text-white");
    document.getElementById("business_drawer_filter").classList.add("text-gray-800", "bg-white");
    document.getElementById("business_drawer_filter").classList.remove("bg-gray-800", "text-white");
    document.getElementById("business_filter_icon").classList.add("hidden")
    document.getElementById("business_drawer_filter_icon").classList.add("hidden")
    document.getElementById("cabrio_filter").classList.add("text-gray-800", "bg-white");
    document.getElementById("cabrio_filter").classList.remove("bg-gray-800", "text-white");
    document.getElementById("cabrio_drawer_filter").classList.add("text-gray-800", "bg-white");
    document.getElementById("cabrio_drawer_filter").classList.remove("bg-gray-800", "text-white");
    document.getElementById("cabrio_filter_icon").classList.add("hidden")
    document.getElementById("cabrio_drawer_filter_icon").classList.add("hidden")
    document.getElementById("minivan_filter").classList.add("text-gray-800", "bg-white");
    document.getElementById("minivan_filter").classList.remove("bg-gray-800", "text-white");
    document.getElementById("minivan_drawer_filter").classList.add("text-gray-800", "bg-white");
    document.getElementById("minivan_drawer_filter").classList.remove("bg-gray-800", "text-white");
    document.getElementById("minivan_filter_icon").classList.add("hidden")
    document.getElementById("minivan_drawer_filter_icon").classList.add("hidden")

    // Красим кнопку фильтров
    document.getElementById("show_filters").classList.add("bg-white")
    document.getElementById("show_filters").classList.remove("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")

    this.auto_drawer_checkboxTarget.checked = true;
    this.manual_drawer_checkboxTarget.checked = true;
    this.robot_drawer_checkboxTarget.checked = true;
    this.variator_drawer_checkboxTarget.checked = true;
    this.gasolina_drawer_checkboxTarget.checked = true;
    this.gasoleo_drawer_checkboxTarget.checked = true;
    this.electro_drawer_checkboxTarget.checked = true;
    this.kasko_drawer_checkboxTarget.checked = false;
    this.super_kasko_drawer_checkboxTarget.checked = false;
    this.no_deposit_drawer_checkboxTarget.checked = false;
    this.card_payment_drawer_checkboxTarget.checked = false;
    this.cash_payment_drawer_checkboxTarget.checked = false;
    this.no_mileage_drawer_checkboxTarget.checked = false;
    this.showResults(false, false);
  }
  showCompacts(event) {
    event.preventDefault();
    console.log("showCompacts")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'compact') {
      search_params.set('car_type', null);
      document.getElementById("compact_filter_icon").classList.add("hidden")
      document.getElementById("compact_drawer_filter_icon").classList.add("hidden")
      document.getElementById("compact_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("compact_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("compact_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("compact_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'compact');
      document.getElementById("compact_filter_icon").classList.remove("hidden")
      document.getElementById("compact_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("compact_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("compact_filter").classList.add("bg-gray-800", "text-white");
      document.getElementById("compact_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("compact_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  showMiddleClass(event) {
    event.preventDefault();
    console.log("showMiddleClass")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_class') == 'middle') {
      search_params.set('car_class', null);
      document.getElementById("middle_filter_icon").classList.add("hidden")
      document.getElementById("middle_drawer_filter_icon").classList.add("hidden")
      document.getElementById("middle_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("middle_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("middle_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("middle_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_class', 'middle');
      document.getElementById("middle_filter_icon").classList.remove("hidden")
      document.getElementById("middle_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("middle_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("middle_filter").classList.add("bg-gray-800", "text-white");
      document.getElementById("middle_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("middle_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  showCrossover(event) {
    event.preventDefault();
    console.log("showCrossover")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'crossover') {
      search_params.set('car_type', null);
      document.getElementById("crossover_filter_icon").classList.add("hidden")
      document.getElementById("crossover_drawer_filter_icon").classList.add("hidden")
      document.getElementById("crossover_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("crossover_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("crossover_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("crossover_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'crossover');
      document.getElementById("crossover_filter_icon").classList.remove("hidden")
      document.getElementById("crossover_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("crossover_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("crossover_filter").classList.add("bg-gray-800", "text-white");
      document.getElementById("crossover_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("crossover_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  showBusinessClass(event) {
    event.preventDefault();
    console.log("showBusinessClass")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_class') == 'business') {
      search_params.set('car_class', null);
      document.getElementById("business_filter_icon").classList.add("hidden")
      document.getElementById("business_drawer_filter_icon").classList.add("hidden")
      document.getElementById("business_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("business_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("business_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("business_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_class', 'business');
      document.getElementById("business_filter_icon").classList.remove("hidden")
      document.getElementById("business_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("business_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("business_filter").classList.add("bg-gray-800", "text-white");
      document.getElementById("business_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("business_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  showCabrio(event) {
    event.preventDefault();
    console.log("showCabrio")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'convertible') {
      search_params.set('car_type', null);
      document.getElementById("cabrio_filter_icon").classList.add("hidden")
      document.getElementById("cabrio_drawer_filter_icon").classList.add("hidden")
      document.getElementById("cabrio_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("cabrio_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("cabrio_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("cabrio_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'convertible');
      document.getElementById("cabrio_filter_icon").classList.remove("hidden")
      document.getElementById("cabrio_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("cabrio_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("cabrio_filter").classList.add("bg-gray-800", "text-white");
      document.getElementById("cabrio_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("cabrio_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  showMinivans(event) {
    event.preventDefault();
    console.log("showMinivans")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'minivan') {
      search_params.set('car_type', null);
      document.getElementById("minivan_filter_icon").classList.add("hidden")
      document.getElementById("minivan_drawer_filter_icon").classList.add("hidden")
      document.getElementById("minivan_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("minivan_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("minivan_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("minivan_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'minivan');
      document.getElementById("minivan_filter_icon").classList.remove("hidden")
      document.getElementById("minivan_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("minivan_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("minivan_filter").classList.add("bg-gray-800", "text-white");
      document.getElementById("minivan_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("minivan_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  // hatchback: "Хэтчбек",
  showHatchback(event) {
    event.preventDefault();
    console.log("showHatchback")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'hatchback') {
      search_params.set('car_type', null);
      document.getElementById("hatchback_drawer_filter_icon").classList.add("hidden")
      document.getElementById("hatchback_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("hatchback_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'hatchback');
      document.getElementById("hatchback_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("hatchback_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("hatchback_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  // sedan: "Седан",
  showSedan(event) {
    event.preventDefault();
    console.log("showSedan")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'sedan') {
      search_params.set('car_type', null);
      document.getElementById("sedan_drawer_filter_icon").classList.add("hidden")
      document.getElementById("sedan_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("sedan_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'sedan');
      document.getElementById("sedan_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("sedan_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("sedan_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  // universal: "Универсал",
  showUniversal(event) {
    event.preventDefault();
    console.log("showUniversal")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'universal') {
      search_params.set('car_type', null);
      document.getElementById("universal_drawer_filter_icon").classList.add("hidden")
      document.getElementById("universal_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("universal_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'universal');
      document.getElementById("universal_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("universal_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("universal_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  // coupe: "Купе",
  showCoupe(event) {
    event.preventDefault();
    console.log("showCoupe")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'coupe') {
      search_params.set('car_type', null);
      document.getElementById("coupe_drawer_filter_icon").classList.add("hidden")
      document.getElementById("coupe_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("coupe_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'coupe');
      document.getElementById("coupe_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("coupe_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("coupe_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  // suv: "Внедорожник",
  showSuv(event) {
    event.preventDefault();
    console.log("showSuv")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'suv') {
      search_params.set('car_type', null);
      document.getElementById("suv_drawer_filter_icon").classList.add("hidden")
      document.getElementById("suv_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("suv_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'suv');
      document.getElementById("suv_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("suv_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("suv_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  // pickup: "Пикап",
  showPickup(event) {
    event.preventDefault();
    console.log("showPickup")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'pickup') {
      search_params.set('car_type', null);
      document.getElementById("pickup_drawer_filter_icon").classList.add("hidden")
      document.getElementById("pickup_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("pickup_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'pickup');
      document.getElementById("pickup_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("pickup_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("pickup_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  // limousine: "Лимузин",
  showLimousine(event) {
    event.preventDefault();
    console.log("showLimousine")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'limousine') {
      search_params.set('car_type', null);
      document.getElementById("limousine_drawer_filter_icon").classList.add("hidden")
      document.getElementById("limousine_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("limousine_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'limousine');
      document.getElementById("limousine_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("limousine_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("limousine_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  // van: "Фургон",
  showVan(event) {
    event.preventDefault();
    console.log("showVan")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'van') {
      search_params.set('car_type', null);
      document.getElementById("van_drawer_filter_icon").classList.add("hidden")
      document.getElementById("van_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("van_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'van');
      document.getElementById("van_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("van_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("van_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  // microbus: "Микроавтобус",
  showMicrobus(event) {
    event.preventDefault();
    console.log("showMicrobus")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'microbus') {
      search_params.set('car_type', null);
      document.getElementById("microbus_drawer_filter_icon").classList.add("hidden")
      document.getElementById("microbus_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("microbus_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'microbus');
      document.getElementById("microbus_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("microbus_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("microbus_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  // campervan: "Автодом",
  showCampervan(event) {
    event.preventDefault();
    console.log("showCampervan")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'campervan') {
      search_params.set('car_type', null);
      document.getElementById("campervan_drawer_filter_icon").classList.add("hidden")
      document.getElementById("campervan_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("campervan_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'campervan');
      document.getElementById("campervan_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("campervan_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("campervan_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  // light_van: "Легковой фургон",
  showLightVan(event) {
    event.preventDefault();
    console.log("showLightVan")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'light_van') {
      search_params.set('car_type', null);
      document.getElementById("light_van_drawer_filter_icon").classList.add("hidden")
      document.getElementById("light_van_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("light_van_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'light_van');
      document.getElementById("light_van_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("light_van_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("light_van_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  // roadster: "Родстер",
  showRoadster(event) {
    event.preventDefault();
    console.log("showRoadster")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'roadster') {
      search_params.set('car_type', null);
      document.getElementById("roadster_drawer_filter_icon").classList.add("hidden")
      document.getElementById("roadster_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("roadster_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'roadster');
      document.getElementById("roadster_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("roadster_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("roadster_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  // sportcar: "Спорткар",
  showSportcar(event) {
    event.preventDefault();
    console.log("showSportcar")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_type') == 'sportcar') {
      search_params.set('car_type', null);
      document.getElementById("sportcar_drawer_filter_icon").classList.add("hidden")
      document.getElementById("sportcar_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("sportcar_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_type', 'sportcar');
      document.getElementById("sportcar_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("sportcar_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("sportcar_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  // econom: "Эконом",
  showEconom(event) {
    event.preventDefault();
    console.log("showEconom")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_class') == 'econom') {
      search_params.set('car_class', null);
      document.getElementById("econom_drawer_filter_icon").classList.add("hidden")
      document.getElementById("econom_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("econom_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_class', 'econom');
      document.getElementById("econom_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("econom_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("econom_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  // commercial: "Коммерческий",
  showCommercial(event) {
    event.preventDefault();
    console.log("showCommercial")
    var search_params = new URLSearchParams(window.location.search)
    document.getElementById("loaders").classList.remove("hidden");
    document.getElementById("filters_loaders").classList.add("hidden");
    if (search_params.get('car_class') == 'commercial') {
      search_params.set('car_class', null);
      document.getElementById("commercial_drawer_filter_icon").classList.add("hidden")
      document.getElementById("commercial_drawer_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("commercial_drawer_filter").classList.remove("bg-gray-800", "text-white");
    } else {
      search_params.set('car_class', 'commercial');
      document.getElementById("commercial_drawer_filter_icon").classList.remove("hidden")
      document.getElementById("all_filter").classList.add("text-gray-800", "bg-white");
      document.getElementById("all_filter").classList.remove("bg-gray-800", "text-white");
      document.getElementById("commercial_drawer_filter").classList.remove("text-gray-800", "bg-white");
      document.getElementById("commercial_drawer_filter").classList.add("bg-gray-800", "text-white");
    }
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  toggleAutoFilter(event) {
    event.preventDefault();
    console.log("toggleAutoFilter")
    document.getElementById("loaders").classList.remove("hidden");
    var search_params = new URLSearchParams(window.location.search)
    // Красим кнопку фильтров
    document.getElementById("show_filters").classList.remove("bg-white")
    document.getElementById("show_filters").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    // Check if input checkbox is checked
    if (this.auto_drawer_checkboxTarget.checked) {
      console.log('auto_gearbox', this.auto_drawer_checkboxTarget.checked)
      search_params.set('auto_gearbox', 'true');
    } else {
      console.log('auto_gearbox', this.auto_drawer_checkboxTarget.checked)
      search_params.set('auto_gearbox', 'false');
    }
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  toggleManualFilter(event) {
    event.preventDefault();
    console.log("toggleManualFilter")
    document.getElementById("loaders").classList.remove("hidden");
    var search_params = new URLSearchParams(window.location.search)
    // Красим кнопку фильтров
    document.getElementById("show_filters").classList.remove("bg-white")
    document.getElementById("show_filters").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    // Check if input checkbox is checked
    if (this.manual_drawer_checkboxTarget.checked) {
      console.log('manual_gearbox', this.manual_drawer_checkboxTarget.checked)
      search_params.set('manual_gearbox', 'true');
    } else {
      console.log('manual_gearbox', this.manual_drawer_checkboxTarget.checked)
      search_params.set('manual_gearbox', 'false');
    }
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  toggleRobotFilter(event) {
    event.preventDefault();
    console.log("toggleRobotFilter")
    document.getElementById("loaders").classList.remove("hidden");
    // Красим кнопку фильтров
    document.getElementById("show_filters").classList.remove("bg-white")
    document.getElementById("show_filters").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    var search_params = new URLSearchParams(window.location.search)
    // Check if input checkbox is checked
    if (this.robot_drawer_checkboxTarget.checked) {
      console.log('robot_gearbox', this.robot_drawer_checkboxTarget.checked)
      search_params.set('robot_gearbox', 'true');
    } else {
      console.log('robot_gearbox', this.robot_drawer_checkboxTarget.checked)
      search_params.set('robot_gearbox', 'false');
    }
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  toggleVariatorFilter(event) {
    event.preventDefault();
    console.log("toggleVariatorFilter")
    document.getElementById("loaders").classList.remove("hidden");
    // Красим кнопку фильтров
    document.getElementById("show_filters").classList.remove("bg-white")
    document.getElementById("show_filters").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    var search_params = new URLSearchParams(window.location.search)
    // Check if input checkbox is checked
    if (this.variator_drawer_checkboxTarget.checked) {
      console.log('variator_gearbox', this.variator_drawer_checkboxTarget.checked)
      search_params.set('variator_gearbox', 'true');
    } else {
      console.log('variator_gearbox', this.variator_drawer_checkboxTarget.checked)
      search_params.set('variator_gearbox', 'false');
    }
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  toggleGasolinaFilter(event) {
    event.preventDefault();
    console.log("toggleGasolinaFilter")
    document.getElementById("loaders").classList.remove("hidden");
    // Красим кнопку фильтров
    document.getElementById("show_filters").classList.remove("bg-white")
    document.getElementById("show_filters").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    var search_params = new URLSearchParams(window.location.search)
    // Check if input checkbox is checked
    if (this.gasolina_drawer_checkboxTarget.checked) {
      console.log('gasolina', this.gasolina_drawer_checkboxTarget.checked)
      search_params.set('gasolina', 'true');
    } else {
      console.log('gasolina', this.gasolina_drawer_checkboxTarget.checked)
      search_params.set('gasolina', 'false');
    }
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  toggleGasoleoFilter(event) {
    event.preventDefault();
    console.log("toggleGasoleoFilter")
    document.getElementById("loaders").classList.remove("hidden");
    // Красим кнопку фильтров
    document.getElementById("show_filters").classList.remove("bg-white")
    document.getElementById("show_filters").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    var search_params = new URLSearchParams(window.location.search)
    // Check if input checkbox is checked
    if (this.gasoleo_drawer_checkboxTarget.checked) {
      console.log('gasoleo', this.gasoleo_drawer_checkboxTarget.checked)
      search_params.set('gasoleo', 'true');
    } else {
      console.log('gasoleo', this.gasoleo_drawer_checkboxTarget.checked)
      search_params.set('gasoleo', 'false');
    }
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  toggleElectroFilter(event) {
    event.preventDefault();
    console.log("toggleElectroFilter")
    document.getElementById("loaders").classList.remove("hidden");
    // Красим кнопку фильтров
    document.getElementById("show_filters").classList.remove("bg-white")
    document.getElementById("show_filters").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    var search_params = new URLSearchParams(window.location.search)
    // Check if input checkbox is checked
    if (this.electro_drawer_checkboxTarget.checked) {
      console.log('electro', this.electro_drawer_checkboxTarget.checked)
      search_params.set('electro', 'true');
    } else {
      console.log('electro', this.electro_drawer_checkboxTarget.checked)
      search_params.set('electro', 'false');
    }
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  toggleKaskoFilter(event) {
    event.preventDefault();
    console.log("toggleKaskoFilter")
    document.getElementById("loaders").classList.remove("hidden");
    // Красим кнопку фильтров
    document.getElementById("show_filters").classList.remove("bg-white")
    document.getElementById("show_filters").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    var search_params = new URLSearchParams(window.location.search)
    // Check if input checkbox is checked
    if (this.kasko_drawer_checkboxTarget.checked) {
      console.log('kasko', this.kasko_drawer_checkboxTarget.checked)
      search_params.set('kasko', 'true');
    } else {
      console.log('kasko', this.kasko_drawer_checkboxTarget.checked)
      search_params.set('kasko', 'false');
    }
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  toggleSuperKaskoFilter(event) {
    event.preventDefault();
    console.log("toggleSuperKaskoFilter")
    document.getElementById("loaders").classList.remove("hidden");
    // Красим кнопку фильтров
    document.getElementById("show_filters").classList.remove("bg-white")
    document.getElementById("show_filters").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    var search_params = new URLSearchParams(window.location.search)
    // Check if input checkbox is checked
    if (this.super_kasko_drawer_checkboxTarget.checked) {
      console.log('super_kasko', this.super_kasko_drawer_checkboxTarget.checked)
      search_params.set('super_kasko', 'true');
    } else {
      console.log('super_kasko', this.super_kasko_drawer_checkboxTarget.checked)
      search_params.set('super_kasko', 'false');
    }
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  toggleNoDepositFilter(event) {
    event.preventDefault();
    console.log("toggleNoDepositFilter")
    document.getElementById("loaders").classList.remove("hidden");
    // Красим кнопку фильтров
    document.getElementById("show_filters").classList.remove("bg-white")
    document.getElementById("show_filters").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    var search_params = new URLSearchParams(window.location.search)
    // Check if input checkbox is checked
    if (this.no_deposit_drawer_checkboxTarget.checked) {
      console.log('no_deposit', this.no_deposit_drawer_checkboxTarget.checked)
      search_params.set('no_deposit', 'true');
    } else {
      console.log('no_deposit', this.no_deposit_drawer_checkboxTarget.checked)
      search_params.set('no_deposit', 'false');
    }
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  toggleCardPaymentFilter(event) {
    event.preventDefault();
    console.log("toggleCardPaymentFilter")
    document.getElementById("loaders").classList.remove("hidden");
    // Красим кнопку фильтров
    document.getElementById("show_filters").classList.remove("bg-white")
    document.getElementById("show_filters").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    var search_params = new URLSearchParams(window.location.search)
    // Check if input checkbox is checked
    if (this.card_payment_drawer_checkboxTarget.checked) {
      console.log('card_payment', this.card_payment_drawer_checkboxTarget.checked)
      search_params.set('card_payment', 'true');
    } else {
      console.log('card_payment', this.card_payment_drawer_checkboxTarget.checked)
      search_params.set('card_payment', 'false');
    }
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  toggleCashPaymentFilter(event) {
    event.preventDefault();
    console.log("toggleCashPaymentFilter")
    document.getElementById("loaders").classList.remove("hidden");
    // Красим кнопку фильтров
    document.getElementById("show_filters").classList.remove("bg-white")
    document.getElementById("show_filters").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    var search_params = new URLSearchParams(window.location.search)
    // Check if input checkbox is checked
    if (this.cash_payment_drawer_checkboxTarget.checked) {
      console.log('cash_payment', this.cash_payment_drawer_checkboxTarget.checked)
      search_params.set('cash_payment', 'true');
    } else {
      console.log('cash_payment', this.cash_payment_drawer_checkboxTarget.checked)
      search_params.set('cash_payment', 'false');
    }
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  toggleNoMileageFilter(event) {
    event.preventDefault();
    console.log("toggleNoMileageFilter")
    document.getElementById("loaders").classList.remove("hidden");
    // Красим кнопку фильтров
    document.getElementById("show_filters").classList.remove("bg-white")
    document.getElementById("show_filters").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    var search_params = new URLSearchParams(window.location.search)
    // Check if input checkbox is checked
    if (this.no_mileage_drawer_checkboxTarget.checked) {
      console.log('no_mileage', this.no_mileage_drawer_checkboxTarget.checked)
      search_params.set('no_mileage', 'true');
    } else {
      console.log('no_mileage', this.no_mileage_drawer_checkboxTarget.checked)
      search_params.set('no_mileage', 'false');
    }
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    this.showResults(false, false);
  }
  sortLowerPrice(event) {
    event.preventDefault();
    console.log("sortLowerPrice")
    document.getElementById("loaders").classList.remove("hidden");
    var search_params = new URLSearchParams(window.location.search)
    search_params.set('sort', 'price_asc');
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    // Красим кнопку сортировки
    document.getElementById("show_sorting").classList.remove("bg-white")
    document.getElementById("show_sorting").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    // красим кнопки
    document.getElementById("sort_standart").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_standart").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_biggest_price").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_biggest_price").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_for_year").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_for_year").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_for_old").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_for_old").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_for_popular").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_for_popular").classList.remove("bg-gray-800", "text-white");

    document.getElementById("sort_lower_price").classList.remove("text-gray-800", "bg-white");
    document.getElementById("sort_lower_price").classList.add("bg-gray-800", "text-white");
    // убираем меню
    document.getElementById("sorting").classList.add("hidden")
    this.showResults(false, false);
  }
  sortBiggestPrice(event) {
    event.preventDefault();
    console.log("sortBiggestPrice")
    document.getElementById("loaders").classList.remove("hidden");
    var search_params = new URLSearchParams(window.location.search)
    search_params.set('sort', 'price_desc');
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    // Красим кнопку сортировки
    document.getElementById("show_sorting").classList.remove("bg-white")
    document.getElementById("show_sorting").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    // красим кнопки
    document.getElementById("sort_standart").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_standart").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_lower_price").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_lower_price").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_for_year").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_for_year").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_for_old").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_for_old").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_for_popular").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_for_popular").classList.remove("bg-gray-800", "text-white");

    document.getElementById("sort_biggest_price").classList.remove("text-gray-800", "bg-white");
    document.getElementById("sort_biggest_price").classList.add("bg-gray-800", "text-white");
    // убираем меню
    document.getElementById("sorting").classList.add("hidden")
    this.showResults(false, false);
  }
  sortForYear(event) {
    event.preventDefault();
    console.log("sortForYear")
    document.getElementById("loaders").classList.remove("hidden");
    var search_params = new URLSearchParams(window.location.search)
    search_params.set('sort', 'year');
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    // Красим кнопку сортировки
    document.getElementById("show_sorting").classList.remove("bg-white")
    document.getElementById("show_sorting").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    // красим кнопки
    document.getElementById("sort_standart").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_standart").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_lower_price").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_lower_price").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_biggest_price").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_biggest_price").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_for_old").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_for_old").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_for_popular").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_for_popular").classList.remove("bg-gray-800", "text-white");

    document.getElementById("sort_for_year").classList.remove("text-gray-800", "bg-white");
    document.getElementById("sort_for_year").classList.add("bg-gray-800", "text-white");
    // убираем меню
    document.getElementById("sorting").classList.add("hidden")
    this.showResults(false, false);
  }
  sortForOld(event) {
    event.preventDefault();
    console.log("sortForOld")
    document.getElementById("loaders").classList.remove("hidden");
    var search_params = new URLSearchParams(window.location.search)
    search_params.set('sort', 'old');
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    // Красим кнопку сортировки
    document.getElementById("show_sorting").classList.remove("bg-white")
    document.getElementById("show_sorting").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    // красим кнопки
    document.getElementById("sort_standart").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_standart").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_lower_price").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_lower_price").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_biggest_price").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_biggest_price").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_for_year").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_for_year").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_for_popular").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_for_popular").classList.remove("bg-gray-800", "text-white");

    document.getElementById("sort_for_old").classList.remove("text-gray-800", "bg-white");
    document.getElementById("sort_for_old").classList.add("bg-gray-800", "text-white");
    // убираем меню
    document.getElementById("sorting").classList.add("hidden")
    this.showResults(false, false);
  }
  sortForPopular(event) {
    event.preventDefault();
    console.log("sortForPopular")
    document.getElementById("loaders").classList.remove("hidden");
    var search_params = new URLSearchParams(window.location.search)
    search_params.set('sort', 'popularity');
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    // Красим кнопку сортировки
    document.getElementById("show_sorting").classList.remove("bg-white")
    document.getElementById("show_sorting").classList.add("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    // красим кнопки
    document.getElementById("sort_standart").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_standart").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_lower_price").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_lower_price").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_biggest_price").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_biggest_price").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_for_year").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_for_year").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_for_old").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_for_old").classList.remove("bg-gray-800", "text-white");

    document.getElementById("sort_for_popular").classList.remove("text-gray-800", "bg-white");
    document.getElementById("sort_for_popular").classList.add("bg-gray-800", "text-white");
    // убираем меню
    document.getElementById("sorting").classList.add("hidden")
    this.showResults(false, false);
  }
  sortStandart(event) {
    event.preventDefault();
    console.log("sortStandart")
    document.getElementById("loaders").classList.remove("hidden");
    var search_params = new URLSearchParams(window.location.search)
    search_params.set('sort', 'standart');
    console.log('search_params', search_params)
    window.history.replaceState({}, '', `${location.pathname}?${search_params}`);
    // Красим кнопку сортировки
    document.getElementById("show_sorting").classList.add("bg-white")
    document.getElementById("show_sorting").classList.remove("rounded-full", "ring-1", "ring-gray-800", "bg-gray-800", "text-white")
    // красим кнопки
    document.getElementById("sort_for_popular").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_for_popular").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_lower_price").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_lower_price").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_biggest_price").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_biggest_price").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_for_year").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_for_year").classList.remove("bg-gray-800", "text-white");
    document.getElementById("sort_for_old").classList.add("text-gray-800", "bg-white");
    document.getElementById("sort_for_old").classList.remove("bg-gray-800", "text-white");

    document.getElementById("sort_standart").classList.remove("text-gray-800", "bg-white");
    document.getElementById("sort_standart").classList.add("bg-gray-800", "text-white");
    // убираем меню
    document.getElementById("sorting").classList.add("hidden")
    this.showResults(false, false);
  }
  truncateString(str, num) {
    // If the length of str is less than or equal to num
    // just return str--don't truncate it.
    if (str.length <= num) {
      return str
    }
    // Return str truncated with '...' concatenated to the end of str.
    return str.slice(0, num) + '...'
  }
  titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
  }
  removeFilters() {
    document.getElementById("manual_filter").classList.remove("border", "border-gray-500");
    document.getElementById("automatic_filter").classList.remove("border", "border-gray-500");
    document.getElementById("remove_filters").classList.add("border", "border-gray-500");
    let cars = document.querySelectorAll(".car");
    cars.forEach((car) => {
      car.classList.remove("hidden");
    });
  }
  manualFilter() {
    document.getElementById("manual_filter").classList.add("border", "border-gray-500");
    document.getElementById("automatic_filter").classList.remove("border", "border-gray-500");
    document.getElementById("remove_filters").classList.remove("border", "border-gray-500");
    document.querySelectorAll(".automatic").forEach((car) => {
      car.classList.add("hidden");
    });
    document.querySelectorAll(".manual").forEach((car) => {
      car.classList.remove("hidden");
    });
  }
  automaticFilter() {
    document.getElementById("automatic_filter").classList.add("border", "border-gray-500");
    document.getElementById("manual_filter").classList.remove("border", "border-gray-500");
    document.getElementById("remove_filters").classList.remove("border", "border-gray-500");
    document.querySelectorAll(".manual").forEach((car) => {
      car.classList.add("hidden");
    });
    document.querySelectorAll(".automatic").forEach((car) => {
      car.classList.remove("hidden");
    });
  }

}
